import { DatePicker, DatePickerProps } from "@mui/lab";
import { TextField, SxProps, Theme } from "@mui/material";
import { addDays } from "date-fns";

export const ExpirationDatePicker: React.FC<
  Omit<DatePickerProps, "renderInput"> & { small?: boolean; inputSx?: SxProps<Theme> }
> = ({ label, value, onChange, minDate, small, inputSx }) => {
  return (
    <DatePicker
      label={label}
      value={value}
      onChange={onChange}
      renderInput={(params: any): any => (
        <TextField {...params} size={small ? "small" : "medium"} sx={inputSx} />
      )}
      openTo="year"
      disableHighlightToday
      minDate={minDate ?? addDays(new Date(), 1)}
    />
  );
};
